import { useFetch } from "@common/hook/useFetch";
import { deleteAddonRoute } from "@api-routes/addons";
import { OFFER_CONFIG } from "@constants";
import { objectToQueryQuestionMark } from "@utils/url";

interface IParams {
    onClose(): void;
    getAddonDetails(): void;
}

export const useRemoveAddonModal = (props: IParams) => {
    const { onClose, getAddonDetails } = props;

    const [deleteAddonState, { deleteCall: deleteAddon }] = useFetch();
    const { isLoading, error } = deleteAddonState;

    const handleConfirmRemoveAddon = async (addonId: number, serviceId: number) => {
        const queryString = objectToQueryQuestionMark({ channelCode: OFFER_CONFIG.CHANNEL, serviceId });

        await deleteAddon(deleteAddonRoute(addonId, queryString)).then((response) => {
            if (response) {
                getAddonDetails();
                onClose();
            }
        });
    };

    return {
        handleConfirmRemoveAddon,
        error,
        isLoading,
    };
};
